// device.js
import { v4 as uuidv4 } from "uuid";

export const getDeviceId = () => {
  if (process.env.REACT_APP_DEV_BYPASS === "true") return "00000000-0000-0000-0000-000000000004";
  let deviceId = localStorage.getItem("device_id");
  if (!deviceId) {
    deviceId = uuidv4();
    localStorage.setItem("device_id", deviceId);
  }
  return deviceId;
}

export default getDeviceId;
